import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { PageState } from '../../../../store/models/page.model';
import { AccountService } from '../../../../store/services/account.service';
import {
  openSnackbar,
  setBannerComponent,
} from '../../../../store/actions/page.action';
import {
  Button,
  ButtonColor,
  ButtonSize,
} from '../../../../store/models/button.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  submitButtonProperties: Button = {
    text: 'Change my password',
    color: ButtonColor.ORANGE,
    size: ButtonSize.BIG,
    onClick: () => this.onSubmit(),
  };

  formGroup: FormGroup;

  private token: string;
  constructor(
    private readonly store$: Store<PageState>,
    private readonly accountService: AccountService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router
  ) {
    this.store$.dispatch(
      setBannerComponent({ banner: 'Change your password' })
    );
    this.activatedRoute.queryParams.subscribe((params: { token: string }) => {
      if (!params.token) {
        this.router.navigate(['/']);
        return;
      }

      this.token = params.token;
    });
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      new_password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\\W).{8,}$'),

      ]),
      confirm_password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        (control: AbstractControl) => {
          if (!this.formGroup) {
            return null;
          }

          const password = this.formGroup.get('new_password');

          if (password.value !== control.value) {
            return {
              not_same_as: true,
            };
          }
        },
      ]),
    });
  }

  private onSubmit() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    if (
      this.formGroup.value.new_password !==
      this.formGroup.value.confirm_password
    ) {
      this.store$.dispatch(
        openSnackbar({
          snackbarData: {
            data: {
              message: 'New password and confirm password do not match.',
              type: 'error',
            },
          },
        })
      );
      return;
    }

    this.accountService
      .resetPassword(
        this.token,
        this.formGroup.value.new_password,
        this.formGroup.value.confirm_password
      )
      .subscribe(
        response => {
          if (response && response.account_id) {
            this.store$.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: 'Password successfully changed. Please log in',
                    type: 'success',
                  },
                },
              })
            );
            this.router.navigate(['/login']);
          }
        },
        error =>
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message:
                    error.error ||
                    'Something went wrong. Please try again later.',
                  type: 'error',
                },
              },
            })
          )
      );
  }

  get new_password(): AbstractControl {
    return this.formGroup.get('new_password');
  }

  get confirm_password(): AbstractControl {
    return this.formGroup.get('confirm_password');
  }

  hasControlErrors(control: AbstractControl) {
    return control.invalid && (control.dirty || control.touched);
  }
}
